<template>
  <div id="app" @click="hideFilter">
    <router-view :key="$router.currentRoute.fullPath" />
    <login-dialog-x v-if="loginDialogShow" />
    <pay-dialog v-if="payDialogShow" />
    <footer-component v-if="showFooter" />
  </div>
</template>

<script>
import PayDialog from './components/Pay.vue'
import LoginDialogX from './components/LoginX.vue'
import FooterComponent from './components/Footer'
import copyToClipboard from './utils/clipboard'
import { getCopyContent } from './api/search'
export default {
  data () {
    return {
      url: '',
      content: '',
      isCopy: false,
      showFooter: false,
    }
  },
  watch: {
    '$route': function (to) {
      if (!['login', 'pay'].includes(to.name)) { 
        this.showFooter = true
      }
    }
  },
  components: {
    PayDialog,
    LoginDialogX,
    FooterComponent
  },
  async mounted () {
    const res = await getCopyContent()
    if (res && res.isCopy) {
      this.isCopy = res.isCopy
      this.content = res.content
    }
  },
  methods: {
    hideFilter() {
      this.$store.commit('hideFilter')
      if (this.isCopy && this.isMobile){
        copyToClipboard(this.content)
      }
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_base.scss";
#app {
  height: 100%;
}
</style>

